// extracted by mini-css-extract-plugin
export default {"setPasswordForm":"JxKSu9z2_7FEQTzTp79A"};